import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { assign, findIndex } from 'lodash';

const initialState = {
  list_doctor: {
    doctors: [],
  } as any,
  select_doctor: {} as any,
  page: 1,
};

const doctorSlice = createSlice({
  name: 'doctor',
  initialState,
  reducers: {
    requestDoctors: (_state, _action: PayloadAction<{ page?: number; limit?: number }>) => {},
    saveDoctors: (state, action: PayloadAction<{ data: any }>) => {
      const { data } = action.payload;
      state.list_doctor = data;
    },
    clearDoctorInList: (state, { payload: { id } }: PayloadAction<{ id: string }>) => {
      const index = findIndex(state.list_doctor.doctors, { id });
      state.list_doctor.doctors.splice(index, 1);
    },
    selectDoctor: (state, action: PayloadAction<{ data: any }>) => {
      state.select_doctor = action.payload.data;
    },
    resetDoctors: (state, _action: PayloadAction) => {
      return assign(state, initialState);
    },
    deleteDoctor: (_state, _action: PayloadAction<{ data: any }>) => undefined,
  },
});

export default doctorSlice;
